import z from "zod";

import { ApiService } from "@/services/ApiService";

export const Employee = z.object({
    id: z.number(),
    name: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    code: z.string(),
    kind: z.string(),
    icon: z.string(),
    signedOnTabletId: z.number().nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export type Employee = z.infer<typeof Employee>;

class EmployeesService extends ApiService {
    public async getEmployees(kind?: string): Promise<Employee[]> {
        const response = await this.get<{ employees: Employee[] }>("apps/employees", { kind });
        return Employee.array().parse(response.employees);
    }

    public async signIn(employeeId: number, tabletId: number): Promise<Employee> {
        const response = await this.post<{ employee: Employee }>("apps/employees/sign_in_on_device", {
            employeeId,
            tabletId,
        });
        return this.attemptParse(Employee, response.employee);
    }

    public async signOut(employeeId: number, tabletId: number): Promise<void> {
        return this.post("apps/employees/sign_out_from_device", { employeeId, tabletId });
    }
}

export default new EmployeesService();
